// Per-page SEO copy. Titles lead with the words buyers actually search for
// ("Bluetooth page turner pedal", "indexed Real Book for forScore") and stay
// under ~60 characters so Google doesn't truncate them; descriptions sit around
// 150-160 characters.
//
// Keep the keys in sync with the routes in App.js.

export var PAGE_SEO = {
  noteturner: {
    title: 'NoteTurner — Bluetooth Page Turner Pedal for forScore & MobileSheets',
    description: 'Hands-free page turns for wind players. The NoteTurner mounts on your instrument instead of the floor — no foot pedal, works with forScore, MobileSheets and any PDF app.',
  },
  forscore: {
    title: 'Indexed Real Books for forScore — Bb, Eb, C & Bass Clef',
    description: 'Searchable, fully indexed fake books, omnibooks and method books for forScore on iPad. Tap a title and land on the tune — in your key, ready for the gig.',
  },
  mobilesheets: {
    title: 'Indexed Real Books for MobileSheets — Android, Windows & iPad',
    description: 'Fully indexed fake books and method books for MobileSheets. Every song title searchable in your key: Bb, Eb, C or bass clef, installed in minutes.',
  },
  muteclip: {
    title: 'MuteClip — Trumpet Mute Holder for Any Music Stand',
    description: 'Keep your mutes within reach on stage. MuteClip clips onto any music stand and holds practice, straight and cup mutes steady through the whole set.',
  },
  belloflex: {
    title: 'BelloFlex — Flexible Cup Mute That Fits Any Trumpet Bell',
    description: 'A flexible TPU cup mute system that adapts to any trumpet bell for the same fit and tone every time. Cup, harmon and straight options.',
  },
  'brass-plank': {
    title: 'The Brass Plank — Condensation Pad for Brass Players',
    description: 'Catch condensation and keep stages, pits and practice rooms dry. Ultra-compact at 20 mm thick, built for trumpet, trombone and low brass.',
  },
  lessons: {
    title: 'Online Trumpet Lessons with Isaías Jiménez',
    description: 'Private and group trumpet lessons with a working professional: range, sound, articulation, jazz language and audition prep, online from anywhere.',
  },
  music: {
    title: 'Music by Isaías Jiménez — Art in Trumpet',
    description: 'Listen to albums, singles and performances by trumpet player, arranger and inventor Isaías Jiménez.',
  },
  gallery: {
    title: 'Gallery — Isaías Jiménez on Stage and in the Studio',
    description: 'Photos from concerts, sessions, pit work and the workshop where JiMendez gear is designed and tested.',
  },
  contact: {
    title: 'Contact JiMendez — Questions, Orders and Support',
    description: 'Questions about an order, a device or an indexed book? Reach Isaías directly and get a real answer from the person who makes the gear.',
  },
  faq: {
    title: 'FAQ — Shipping, Returns, Batteries and Downloads',
    description: 'Answers on delivery times, international shipping, battery life and replacement, damaged orders, returns and how your digital files reach you.',
  },
  distributors: {
    title: 'Where to Buy JiMendez Gear — Distributors & Stores',
    description: 'Music stores and distributors stocking NoteTurner, MuteClip, BelloFlex and the Brass Plank, plus how to become one.',
  },
  arrangements: {
    title: 'Trumpet & Big Band Arrangements by Isaías Jiménez',
    description: 'Original arrangements and transcriptions for trumpet, brass sections and big band, delivered as print-ready files.',
  },
  toneregistry: {
    title: 'ToneRegistry — Register and Protect Your Instrument',
    description: 'Record your instrument’s serial number and details so it can be identified and recovered if it is ever lost or stolen.',
  },
  terms: {
    title: 'Terms of Service',
    description: 'The terms that apply when you buy physical gear or digital indexed files from JiMendez.com.',
  },
  privacy: {
    title: 'Privacy Policy',
    description: 'What JiMendez.com collects when you order, how it is used, and how to have it removed.',
  },
  refund: {
    title: 'Refund & Return Policy',
    description: 'How returns, exchanges and refunds work for devices and for digital indexed files.',
  },
};

var SITE = 'https://www.jimendez.com';

export function breadcrumbSchema(trail) {
  // trail: [{ name, path }] — path omitted on the final (current) item.
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: trail.map(function(step, i) {
      var item = {
        '@type': 'ListItem',
        position: i + 1,
        name: step.name,
      };
      if (step.path) item.item = SITE + step.path;
      return item;
    }),
  };
}

export function faqSchema(pairs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: pairs.map(function(qa) {
      return {
        '@type': 'Question',
        name: qa.q,
        acceptedAnswer: { '@type': 'Answer', text: qa.a },
      };
    }),
  };
}
